<template>
    <div class="content-account container">
        <HeaderIntern />
        <template v-if="prizes.length > 0">
            <div class="content-account-prizes regular">
                <div class="content-account-prizes-card" v-for="prize, i in prizes" :key="i" :class="{ 'received': prize.status === 'anulado' }">
                    <div class="content-account-prizes-card-img" @click="openDetailModal(prize)"
                        :style="{
                            backgroundImage: `url('${prize.prize_congrats_path}')`,
                        }"
                        >
                        <div class="content-account-prizes-card-status">
                            <p
                            :class="{
                                'onValidation': prize.status === 'em validação',
                                'rejected': prize.status === 'anulado',
                                'validated': prize.status === 'validado'
                            }"
                            >{{ prize.status }}</p>
                        </div>
                        <div class="content-account-prizes-card-text">
                            <p>{{ prize.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-account-prizes d-lg-none">
                <Swiper>
                    <SwiperSlide v-for="prize, i in prizes" :key="i">
                        <div class="content-account-prizes-card" :class="{ 'received': prize.status === 'anulado' }">
                            <div class="content-account-prizes-card-img" @click="openDetailModal(prize)"
                                :style="{
                                                backgroundImage: `url('${prize.prize_congrats_path}')`,
                                            }">
                                <div class="content-account-prizes-card-status">
                                    <p
                                    :class="{
                                        'onValidation': prize.status === 'em validação',
                                        'rejected': prize.status === 'anulado',
                                        'validated': prize.status === 'validado'
                                    }"
                                    >{{ prize.status }}</p>
                                </div>
                                <div class="content-account-prizes-card-text">
                                    <p>{{ prize.name }}</p>
                                </div>
                            </div>
                        </div> 
                    </SwiperSlide>
                </Swiper>
            </div>
        </template>
        <template v-else-if=" isLoading == false">
            <div class="content-account-prizes">
                <div class="content-account-prizes-card" style="background: rgb(251,249,237);
                    background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(227,227,227,1) 100%);">
                    <div class="content-account-prizes-card-img no-prize">
                        <div class="content-account-prizes-card-text" style="bottom: 10px!important;">
                            <p style="color: #173F35; margin: 10px;">Ainda não ganhou nenhum prémio</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="content-account-seemore">
            <router-link tag="button" to="/account-code">
                <svg id="Group_4138" data-name="Group 4138" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28.255" height="38.1" viewBox="0 0 28.255 38.1">
                    <defs>
                        <clipPath id="clip-path">
                        <rect id="Rectangle_2244" data-name="Rectangle 2244" width="28.255" height="38.1" fill="none"/>
                        </clipPath>
                    </defs>
                    <g id="Group_4138-2" data-name="Group 4138" clip-path="url(#clip-path)">
                        <path id="Path_5392" data-name="Path 5392" d="M4.281,38.1A4.285,4.285,0,0,1,0,33.821V4.281A4.285,4.285,0,0,1,4.28,0h11.5a4.255,4.255,0,0,1,3.029,1.258L27,9.451a4.293,4.293,0,0,1,1.251,3.022V33.82a4.285,4.285,0,0,1-4.28,4.281Zm12.308-8.56A5.517,5.517,0,0,1,22.1,35.051v1.874h1.875a3.113,3.113,0,0,0,3.1-3.1V13.483H17.82a3.054,3.054,0,0,1-3.049-3.05V1.175H4.281a3.113,3.113,0,0,0-3.1,3.105V33.821a3.113,3.113,0,0,0,3.1,3.1H6.154V35.051a5.517,5.517,0,0,1,5.511-5.511Zm-4.924,1.175a4.342,4.342,0,0,0-4.336,4.336v1.875h13.6V35.051a4.341,4.341,0,0,0-4.336-4.336Zm4.281-20.288A1.882,1.882,0,0,0,17.818,12.3h9.336l-.263-.836a2.964,2.964,0,0,0-.716-1.19l-8.209-8.2a3.084,3.084,0,0,0-1.177-.71l-.844-.277ZM14.127,25.793a4.281,4.281,0,1,1,4.281-4.28,4.285,4.285,0,0,1-4.281,4.28m0-7.385a3.1,3.1,0,1,0,3.1,3.106,3.108,3.108,0,0,0-3.1-3.106"/>
                    </g>
                </svg>
                ver participações
            </router-link>
        </div>
        <div class="content-account-youraccount">
            <div class="content-account-youraccount-title">
                <h3>Dados da sua conta</h3>
            </div>
            <div class="content-account-youraccount-buttons row">
                <div class="content-account-youraccount-buttons-itens col-md-3">
                    <button @click="$bvModal.show('modal-changedata')">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28.255" height="38.1" viewBox="0 0 28.255 38.1">
                            <defs>
                                <clipPath id="clip-path">
                                <rect id="Rectangle_2244" data-name="Rectangle 2244" width="28.255" height="38.1" fill="#f9f9f9"/>
                                </clipPath>
                            </defs>
                            <g id="Group_4138" data-name="Group 4138" clip-path="url(#clip-path)">
                                <path id="Path_5392" data-name="Path 5392" d="M4.281,38.1A4.285,4.285,0,0,1,0,33.821V4.281A4.285,4.285,0,0,1,4.28,0h11.5a4.255,4.255,0,0,1,3.029,1.258L27,9.451a4.293,4.293,0,0,1,1.251,3.022V33.82a4.285,4.285,0,0,1-4.28,4.281Zm12.308-8.56A5.517,5.517,0,0,1,22.1,35.051v1.874h1.875a3.113,3.113,0,0,0,3.1-3.1V13.483H17.82a3.054,3.054,0,0,1-3.049-3.05V1.175H4.281a3.113,3.113,0,0,0-3.1,3.105V33.821a3.113,3.113,0,0,0,3.1,3.1H6.154V35.051a5.517,5.517,0,0,1,5.511-5.511Zm-4.924,1.175a4.342,4.342,0,0,0-4.336,4.336v1.875h13.6V35.051a4.341,4.341,0,0,0-4.336-4.336Zm4.281-20.288A1.882,1.882,0,0,0,17.818,12.3h9.336l-.263-.836a2.964,2.964,0,0,0-.716-1.19l-8.209-8.2a3.084,3.084,0,0,0-1.177-.71l-.844-.277ZM14.127,25.793a4.281,4.281,0,1,1,4.281-4.28,4.285,4.285,0,0,1-4.281,4.28m0-7.385a3.1,3.1,0,1,0,3.1,3.106,3.108,3.108,0,0,0-3.1-3.106" fill="#f9f9f9"/>
                            </g>
                        </svg>
                        alterar dados
                    </button>
                </div>
                <div class="content-account-youraccount-buttons-itens col-md-3">
                    <button @click="$bvModal.show('modal-changepass')">
                        <svg id="Group_1719" data-name="Group 1719" xmlns="http://www.w3.org/2000/svg" width="28.254" height="13.657" viewBox="0 0 28.254 13.657">
                            <path id="Path_4000" data-name="Path 4000" d="M26.512,132H1.742A1.744,1.744,0,0,0,0,133.742v5.308a1.744,1.744,0,0,0,1.742,1.742H17.223a.415.415,0,1,0,0-.829H1.742a.913.913,0,0,1-.912-.912v-5.308a.913.913,0,0,1,.912-.912H26.512a.913.913,0,0,1,.912.912v3.981a.415.415,0,0,0,.829,0v-3.981A1.744,1.744,0,0,0,26.512,132Z" transform="translate(0 -132)" fill="#f9f9f9"/>
                            <path id="Path_4001" data-name="Path 4001" d="M343.907,184.049v-.538a3.511,3.511,0,1,0-7.022,0v.538A1.3,1.3,0,0,0,336,185.28V189.7a1.3,1.3,0,0,0,1.3,1.3h6.193a1.3,1.3,0,0,0,1.3-1.3V185.28A1.3,1.3,0,0,0,343.907,184.049Zm-3.511-3.22a2.685,2.685,0,0,1,2.682,2.682v.47h-5.363v-.47A2.685,2.685,0,0,1,340.4,180.829Zm3.566,8.874a.47.47,0,0,1-.47.47H337.3a.47.47,0,0,1-.47-.47V185.28a.47.47,0,0,1,.47-.47h6.193a.471.471,0,0,1,.47.47Z" transform="translate(-317.422 -177.346)" fill="#f9f9f9"/>
                            <path id="Path_4002" data-name="Path 4002" d="M56.124,173.092a.415.415,0,0,0-.566-.152l-.91.526v-1.051a.415.415,0,1,0-.829,0v1.051l-.91-.526a.415.415,0,1,0-.415.718l.91.526-.91.526a.415.415,0,1,0,.415.718l.91-.526v1.051a.415.415,0,1,0,.829,0V174.9l.91.526a.415.415,0,0,0,.415-.718l-.91-.526.91-.526A.415.415,0,0,0,56.124,173.092Z" transform="translate(-49.395 -169.788)" fill="#f9f9f9"/>
                            <path id="Path_4003" data-name="Path 4003" d="M152.124,173.092a.415.415,0,0,0-.566-.152l-.91.526v-1.051a.415.415,0,0,0-.829,0v1.051l-.91-.526a.415.415,0,0,0-.415.718l.91.526-.91.526a.415.415,0,1,0,.415.718l.91-.526v1.051a.415.415,0,0,0,.829,0V174.9l.91.526a.415.415,0,0,0,.415-.718l-.91-.526.91-.526A.415.415,0,0,0,152.124,173.092Z" transform="translate(-140.087 -169.788)" fill="#f9f9f9"/>
                            <path id="Path_4004" data-name="Path 4004" d="M248.124,173.092a.415.415,0,0,0-.566-.152l-.91.526v-1.051a.415.415,0,1,0-.829,0v1.051l-.91-.526a.415.415,0,1,0-.415.718l.91.526-.91.526a.415.415,0,1,0,.415.718l.91-.526v1.051a.415.415,0,1,0,.829,0V174.9l.91.526a.415.415,0,0,0,.415-.718l-.91-.526.91-.526A.415.415,0,0,0,248.124,173.092Z" transform="translate(-230.779 -169.788)" fill="#f9f9f9"/>
                            <path id="Path_4005" data-name="Path 4005" d="M393.3,284a1.3,1.3,0,0,0-.415,2.53v.538a.415.415,0,1,0,.829,0v-.538A1.3,1.3,0,0,0,393.3,284Zm0,1.769a.47.47,0,1,1,.47-.47A.47.47,0,0,1,393.3,285.769Z" transform="translate(-370.326 -275.596)" fill="#f9f9f9"/>
                        </svg>
                        Alterar Palavra-passe
                    </button>
                </div>
                <div class="content-account-youraccount-buttons-itens col-md-3">
                    <button @click="$bvModal.show('modal-phone')">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28" viewBox="0 0 28 28">
                            <defs>
                                <clipPath id="clip-path">
                                <rect id="Rectangle_2247" data-name="Rectangle 2247" width="28" height="28" transform="translate(0 0.254)" fill="#f9f9f9"/>
                                </clipPath>
                            </defs>
                            <g id="Group_4156" data-name="Group 4156" transform="translate(0.48 0.055)">
                                <g id="Group_4155" data-name="Group 4155" transform="translate(-0.48 -0.309)" clip-path="url(#clip-path)">
                                <path id="Path_5468" data-name="Path 5468" d="M286.351,20.917a2.364,2.364,0,0,1-2.362-2.362V2.362A2.365,2.365,0,0,1,285.748.078l.031-.008.029-.014A.555.555,0,0,1,286.051,0c.034,0,.072,0,.118,0h.042c.053,0,.1,0,.14,0h7.8c.042,0,.088,0,.14,0h.042c.046,0,.083,0,.117,0a.555.555,0,0,1,.243.056l.029.014.031.008a2.364,2.364,0,0,1,1.759,2.283V18.555a2.364,2.364,0,0,1-2.362,2.362Zm-.263-19.763a1.244,1.244,0,0,0-.974,1.208V18.555a1.238,1.238,0,0,0,1.237,1.237h7.8a1.238,1.238,0,0,0,1.237-1.237V2.362a1.244,1.244,0,0,0-.974-1.208l-.1-.022-.095.037a.633.633,0,0,0-.406.593,1.764,1.764,0,0,1-1.762,1.762h-3.6a1.764,1.764,0,0,1-1.762-1.762.633.633,0,0,0-.406-.593l-.095-.037Zm1.707.357a1.773,1.773,0,0,1,.018.252.638.638,0,0,0,.637.637h3.6a.638.638,0,0,0,.637-.637,1.775,1.775,0,0,1,.018-.252l.055-.385h-5.02Z" transform="translate(-268.276 0.021)" fill="#f9f9f9"/>
                                <path id="Path_5469" data-name="Path 5469" d="M2.362,151.989A2.364,2.364,0,0,1,0,149.627V133.434a2.364,2.364,0,0,1,2.362-2.362h7.8a2.364,2.364,0,0,1,2.362,2.362v16.194a2.364,2.364,0,0,1-2.362,2.362Zm-1.237-2.362a1.238,1.238,0,0,0,1.237,1.237h7.8a1.238,1.238,0,0,0,1.237-1.237V148.39H1.125ZM2.362,132.2a1.238,1.238,0,0,0-1.237,1.237v13.832H11.4V133.434a1.238,1.238,0,0,0-1.237-1.237Z" transform="translate(0.119 -123.854)" fill="#f9f9f9"/>
                                <path id="Path_5470" data-name="Path 5470" d="M159.509,103.082Z" transform="translate(-150.631 -97.401)" fill="#f9f9f9"/>
                                <path id="Path_5471" data-name="Path 5471" d="M122.316,5.323l-.055,0-.039-.006-.015,0-.017,0-.036-.009-.022-.008L122.1,5.28l-.024-.012-.025-.012-.029-.018-.015-.009c-.013-.009-.025-.018-.037-.027l-.012-.009a.568.568,0,0,1-.044-.04l-1.593-1.568a.562.562,0,1,1,.788-.8l.632.621.013-.787A2.69,2.69,0,0,1,124.448,0h1.066a.562.562,0,0,1,0,1.125h-1.066A1.551,1.551,0,0,0,122.879,2.6l-.036.853.677-.666a.558.558,0,0,1,.394-.161.562.562,0,0,1,.4.962L122.72,5.151a.619.619,0,0,1-.047.043l-.012.009-.036.026-.015.009-.031.019-.02.009-.029.014-.029.01-.022.008-.036.009-.017,0-.056.008-.053,0Z" transform="translate(-113.438 0.021)" fill="#f9f9f9"/>
                                <path id="Path_5472" data-name="Path 5472" d="M284.551,420.384a.562.562,0,0,1,0-1.125h1.066a1.551,1.551,0,0,0,1.569-1.475l.035-.852-.676.664a.563.563,0,1,1-.79-.8l1.6-1.574a.559.559,0,0,1,.225-.135l.009,0,.045-.011.011,0a.566.566,0,0,1,.106-.01l.05,0,.013,0,.048.007.017,0,.035.009.019.007.032.012.017.008.032.015.014.009.03.018.015.011.028.021.017.015.025.022,1.6,1.573a.562.562,0,1,1-.788.8l-.632-.622-.012.788a2.69,2.69,0,0,1-2.694,2.62Z" transform="translate(-268.276 -392.249)" fill="#f9f9f9"/>
                                </g>
                            </g>
                        </svg>
                        Alterar Nº telemóvel
                    </button>
                </div>
                <div class="content-account-youraccount-buttons-itens col-md-3">
                    <button @click="$bvModal.show('modal-rgpd')">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28.095" height="30" viewBox="0 0 28.095 30">
                            <defs>
                                <clipPath id="clip-path">
                                <rect id="Rectangle_2245" data-name="Rectangle 2245" width="28.095" height="30" fill="#f9f9f9"/>
                                </clipPath>
                            </defs>
                            <g id="Group_4140" data-name="Group 4140" transform="translate(0 -100)">
                                <g id="Group_4139" data-name="Group 4139" transform="translate(0 100)" clip-path="url(#clip-path)">
                                <path id="Path_5393" data-name="Path 5393" d="M14.039,30c-1.361,0-4.869-1.781-8.078-5.605A26.048,26.048,0,0,1,0,7.313,2.57,2.57,0,0,1,1.6,4.972L13.051.2a2.586,2.586,0,0,1,1.995,0L26.5,4.971a2.573,2.573,0,0,1,1.6,2.346C28.094,22.7,16.82,30,14.039,30m0-28.628a1.229,1.229,0,0,0-.475.1L2.119,6.239a1.22,1.22,0,0,0-.746,1.127,25.173,25.173,0,0,0,5.3,15.653c2.7,3.468,5.869,5.573,7.367,5.605,2.716,0,12.663-7.732,12.666-21.237a1.223,1.223,0,0,0-.749-1.148L14.512,1.468a1.164,1.164,0,0,0-.465-.1h0Zm-1.588,17.18a.706.706,0,0,1-.487-.2L8.79,15.171A.687.687,0,0,1,9.275,14h.01a.667.667,0,0,1,.473.2l2.7,2.7,5.878-5.879a.679.679,0,0,1,.429-.2h.056a.687.687,0,0,1,.485,1.173l-6.363,6.363a.688.688,0,0,1-.484.2" transform="translate(0.001 0)" fill="#f9f9f9"/>
                                </g>
                            </g>
                        </svg>
                        RGPD
                    </button>
                </div>
            </div>
        </div>
        <div class="content-account-logout">
            <button @click="logOff()">TERMINAR SESSÃO</button>
        </div>
        <ChangeData />
        <ChangePassword />
        <Rgpd />
        <Phone />
        <CodeDetail :code="codeDetail"/>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import ChangeData from "../../components/modals/ChangeData.vue";
import ChangePassword from "../../components/modals/ChangePassword.vue";
import Rgpd from "../../components/modals/Rgpd.vue";
import HeaderIntern from "../../components/headers/HeaderIntern.vue";
import Phone from "../../components/modals/Phone.vue";
import CodeDetail from "../../components/modals/CodeDetail.vue";

import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';

export default {
  components: {
    Swiper,
    SwiperSlide,
    ChangeData,
    ChangePassword,
    Rgpd,
    HeaderIntern,
    Phone,
    CodeDetail
  },
  data() {
    return {
      prizes: [],
      codeDetail: {},
      swiperProducts: {
        slidesPerView: 1.3,
        spaceBetween: 15,
        loop: false,
        speed: 800,
        watchOverflow: true,
        clickable: true,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.3,
          },
          991: {
            slidesPerView: 1.3,
          },
        },
      },
      data1: [],
      data2: [],
    };
  },
  computed: {
    ...mapGetters(["user", "isLoading"]),
  },
  methods: {
    ...mapActions(["accountLogout"]),
    logOff(){
        this.accountLogout()
        .then(() => {
            this.$router.push('/home');
        }).catch((error) => {
            console.log(error);
        });
    },
    getPrizes(){
        this.$store.dispatch("setIsLoading", true);
        axios.post('/api/v1/user/prizes', {
            user_id: this.user.id,
        }).then((response) => {
            if (response.data.success === true) {
                const filteredPrizes = response.data.data.filter(prize => prize.id !== 5);
                this.prizes = filteredPrizes.slice(0, 4);
            } else {
                this.$swal.fire({
                    type: 'error',
                    title: 'Erro',
                    text: response.data.message,
                    timer: 3000,
                });
            }
        }).catch((error) => {
            this.$swal.fire({
                type: 'error',
                title: 'Erro',
                text: error,
                timer: 3000,
            });
        }).finally(() => {
            this.$store.dispatch("setIsLoading", false);
        });
    },
    openDetailModal(code) {
        this.codeDetail = code;
        this.$bvModal.show('modal-codedetail');
    },
  },
  mounted(){
    this.getPrizes();
    // se user is empty
    if (Object.keys(this.user).length === 0) {
        this.logOff();
    }
  }
};
</script>
<style lang="scss" >
.received{
    background-color: gray !important;
}
.no-prize{
    background-image: url('~@/assets/img/prizes/no-prize.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 80%!important;
}
.content-account{
    margin: 220px auto 100px auto;
    width: 100%;
    &-prizes{
        margin: 50px auto;
        justify-content: flex-start;
        &-card{
            width: 260px;
            height: 240px;
            background-color: var(--main-color);
            position: relative;
            border-radius: 20px;
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
            padding: 30px;
            &-img{
                border-radius: 20px;
                height: 100%;
                background-repeat: no-repeat;
                background-position: top center;
                background-size: auto 100%;
            }
            &-status{
                position: absolute;
                top: -15px;
                right: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                p{
                    width: 150px;
                    color: var(--black);
                    font-family: 'Font Bold';
                    font-size: 16px;
                    line-height: 22px;
                    text-align: center;
                    padding: 5px 0;  
                    text-transform: uppercase;      
                    border-radius: 10px;        
                }
            }
            &-text{
                position: absolute;
                bottom: 30px;
                right: 0;
                left: 0;
                p{
                    color: var(--white);
                    margin: 5px 0;
                    line-height: 24px;
                }
            }   
        }
    }
    &-seemore{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 50px;
        button{
            width: 318px;
            height: 56px;
            background: var(--white);
            border-radius: 10px;
            border: none;
            background: rgb(254,206,9);
            background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
            color: black;
            font-family: 'Font Bold';
            font-size: 18px;
            line-height: 18px;
            text-transform: uppercase;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            &:hover{
                background: var(--main-color);
                color: var(--white);
            }
        }
    }
    &-youraccount{
        margin: 50px auto;
        &-title{
            width: 100%;
            text-align: left;
        }
        &-buttons{
            margin-top: 30px;
            &-itens{
                padding-bottom: 30px;
            }
            button{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: 15px;
                padding: 0 20px;
                width: 100%;
                height: 70px;
                background: rgb(254,206,9);
                background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
                border-radius: 10px;
                border: none;
                color: black;
                font-family: 'Font Bold';
                font-size: 18px;
                line-height: 18px;
                text-transform: uppercase;
                text-align: left;
                cursor: pointer;
                svg{
                    color: black;
                    stroke: black;
                }
            }
        }
    }
    &-logout{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        margin-top: 50px;
        align-items: center;
        button{
            width: 260px;
            height: 70px;
            background: var(--white);
            border-radius: 10px;
            border: 1px solid #B8B8B8;
            color: #B8B8B8;
            font-family: 'Font Bold';
            font-size: 18px;
            line-height: 18px;
            text-transform: uppercase;
            cursor: pointer;
            &:hover{
                background: var(--main-color);
                color: var(--white);
            }
            @media screen and (max-width: 500px){
                width: 100%;
            }
        }
    }
}
.swiper-container{
    overflow: visible !important;
}
.swiper-slide{
    width: 280px!important;
}
.regular{
    display: flex;
    gap: 20px;
    @media screen and (max-width: 992px){
        display: none;
    }
}
.onValidation{
    background-color: #FFCF00;
}
.rejected{
    background-color: #F5891F;
}
.validated{
    background-color: #A5E971;
}
</style>